<template>

    <div class="ui grid container">
        <div class="row" v-if="showStoreOfferControl">
            <div class="sixteen wide column right aligned">
                 <div class="ui toggle checkbox">
                    <input type="checkbox" :checked="isStoreOffer" @change="toggleStoreOffer">
                    <label>採用門市價</label>
                </div>
            </div>
        </div>
        <div class="row" v-if="inCart && price">  
            <div class="ten wide column">
            </div>
            <div class="six wide column">
                <div class="ui horizontal blue large statistic right floated">
                    <div class="value price">{{price}}</div>
                </div>          
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {};
        },
        props: ['in-cart', 'price', 'is-store-offer', 'show-store-offer-control'],
        methods:{
            toggleStoreOffer(){
                this.$emit('storeOfferChanged', !this.isStoreOffer)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// TotalPrice.vue?0914e5b4